import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PartyModeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"party_mode"}/>
}
